import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { MicroservicesEndpoint } from "common/services/ApiServerService";
import { authenticatedFetch } from "core/components/AuthProvider";
import { UnderwritingStatusClient, UnderwritingStatusResponse } from "common/services/microservices/sales-client";

const { Option } = Select;

interface UnderwritingStatusSelectProps {
  selected: number | undefined;
  onUnderwritingStatusSelected: (underwritingStatusId: number) => void;
  style?: React.CSSProperties;
}

export default function UnderwritingStatusSelect(props: UnderwritingStatusSelectProps) {
  const { selected, onUnderwritingStatusSelected, style } = props;
  const [underwritingStatusList, setUnderwritingStatusList] = useState<UnderwritingStatusResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    authenticatedFetch(MicroservicesEndpoint.sales, UnderwritingStatusClient, (c) => {
      setLoading(true);
      return c.getUnderwritingStatuses();
    }).then((res) => {
      setLoading(false);
      setUnderwritingStatusList(res);
    });
  }, []);

  return (
    <Select
      allowClear
      showSearch
      style={style}
      loading={loading}
      value={selected}
      placeholder="Select an underwriting status"
      optionFilterProp="children"
      onChange={(value) => onUnderwritingStatusSelected(value)}
      filterOption={(input: string, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
    >
      {underwritingStatusList
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((item) => (
          <Option key={item.ensSaleUnderwrittingStatusTid} value={item.ensSaleUnderwrittingStatusTid}>
            {item.name}
          </Option>
        ))}
    </Select>
  );
}
